

import React, {  useEffect, useState } from 'react'
import { quizQuestionModel } from '../../../Interfaces/quizQuestionModel'
import Answers from '../../../Interfaces/Answers';
import { useValidateQuizMutation } from '../../../API/StartQuizQApi';
import apiResponse from '../../../Interfaces/apiResponse';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import TimeLeft from './TimeLeft';
import Loader from '../../../Helper/Loader';
import baseUrlPathImage from '../../../API/baseUrlPathImage';



interface props{
    questions:quizQuestionModel[],
    userId:string,
    getLevel:any,
}

function QuizView({questions,userId,getLevel}:props) {
//console.log(questions);
const navigate = useNavigate();
const [loading, setLoading] = useState(false);
const [currentIndex, setCurrentIndex] = useState(0);
const [answers, setAnswers] = useState<Answers[]>([]);
const [selectedAnswer, setSelectedAnswer] = useState<string>('');
const [validateQuiz] = useValidateQuizMutation();

const handleNext = () => {
    setCurrentIndex((prev) =>
      prev < questions.length - 1 ? prev + 1 : prev
    );
   

  };

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev > 0 ? prev - 1 : prev));
  };

  const handleSubmit = async () => {
    // console.log(JSON.stringify(answers, null, 2));
            setLoading(true);
             try {
              const response:apiResponse = await validateQuiz(answers);
              
               if(response.data?.isSuccess == true){
                       toast.success('Submitted Successfully!', {
                           position: "top-right", 
                           autoClose: 5000, 
                         });
                   navigate("/startquiz/quiz/results",{ state: { scoreResults : response.data?.result } });
                   }else if(response.data?.exist == true){
                     toast.error('Question already exist!', {
                       position: "top-right", 
                       autoClose: 5000, 
                     });
                   }
                   else{
                     toast.error('Something went wrong!', {
                         position: "top-right", 
                         autoClose: 5000, 
                       });
                   }
                 
               } catch (error) {
                 console.error('Error:', error);
                
               } finally {
                 setLoading(false);
               }
         
  }
const currentQuestion = questions[currentIndex];
useEffect(() => {
  if (!currentQuestion) return;

  const existingAnswer = answers.find(a => a.questionId === currentQuestion.question.id);
  if (existingAnswer) {
    setSelectedAnswer(existingAnswer.answer); // restore previous answer
  } else {
    setSelectedAnswer(''); // clear selection for new question
  }
}, [currentIndex, answers, currentQuestion]);



const [getImageUrl, setGetImageUrl] = useState({
    questionImageUrl: !currentQuestion?.question?.questionImageUrl  ? `${baseUrlPathImage.test}/${ currentQuestion?.question?.questionImageUrl}` :null,
    answerKeyImageUrl:!currentQuestion?.question?.answerKeyImageUrl  ? `${baseUrlPathImage.test}/${currentQuestion?.question?.answerKeyImageUrl}`:null,
    choiceAImageUrl:!currentQuestion?.question?.choice?.choiceAImageUrl  ? `${baseUrlPathImage.test}/${currentQuestion?.question.choice?.choiceAImageUrl}`:null,
    choiceBImageUrl:!currentQuestion?.question?.choice?.choiceBImageUrl  ? `${baseUrlPathImage.test}/${currentQuestion?.question.choice?.choiceBImageUrl}`:null,
    choiceCImageUrl:!currentQuestion?.question?.choice?.choiceCImageUrl  ? `${baseUrlPathImage.test}/${currentQuestion?.question.choice?.choiceCImageUrl}`:null,
    choiceDImageUrl:!currentQuestion?.question?.choice?.choiceCImageUrl ? `${baseUrlPathImage.test}/${currentQuestion?.question.choice?.choiceCImageUrl}`:null,
    choiceEImageUrl:!currentQuestion?.question?.choice?.choiceEImageUrl  ? `${baseUrlPathImage.test}/${currentQuestion?.question.choice?.choiceEImageUrl}`:null,
  });
 

    return (
      <div className="container mt-4">
        <TimeLeft getLevel={getLevel} onTimeUp={handleSubmit} />
        <h4>Current Quiz : {getLevel.quizLevel == 3 ? "Hard" : "Easy"} : {getLevel.itemQuestions}</h4>
        <div className="card p-3 mt-3">
          <p>
            <strong>Question {currentIndex + 1}:</strong><br />
            {currentQuestion?.question?.questionText
              ?.split('\n')
              ?.map((line, index) => (
                <span key={index}>
                  {line}
                  <br />
                </span>
              ))}
            {
              currentQuestion?.question?.questionImageUrl
              &&
              <img src={`${baseUrlPathImage.test}/${currentQuestion?.question?.questionImageUrl}`} alt="Question" width="350" />
            }
          </p>
          <div style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "1rem"
          }}>
            <div style={{ minWidth: "150px" }}>
              <span>1</span>
              <input
                className="ms-1"
                type="radio"
                name={`${currentQuestion?.question.id}`}
                value={!currentQuestion?.question?.choice?.choiceAImageUrl
                  ? currentQuestion?.question.choice?.a
                  : currentQuestion?.question?.choice?.choiceAImageUrl}

                checked={!currentQuestion?.question?.choice?.choiceAImageUrl
                  ? selectedAnswer === currentQuestion?.question.choice?.a
                  : selectedAnswer === currentQuestion?.question?.choice?.choiceAImageUrl}
                onChange={(e) => {
                  const value = e.target.value;
                  setSelectedAnswer(value);

                  // update answers state
                  setAnswers(prev => {
                    const existing = prev.find(a => a.questionId === currentQuestion?.question.id);
                    if (existing) {
                      return prev.map(a =>
                        a.questionId === currentQuestion?.question.id ? {
                          ...a, answer: value,
                          quizId: currentQuestion.quizId, userId: userId
                        } : a
                      );
                    } else {
                      return [...prev, {
                        questionId: currentQuestion?.question.id!,
                        answer: value, quizId: currentQuestion.quizId, userId: userId
                      }];
                    }
                  });
                }}
              />{" "}
              {
                currentQuestion?.question?.choice?.choiceAImageUrl ?
                  <img src={`${baseUrlPathImage.test}/${currentQuestion?.question.choice?.choiceAImageUrl}`} alt="ChoiceA" width="200" /> :
                  currentQuestion?.question.choice?.a
              }
            </div>

            <div style={{ minWidth: "150px" }}>
              <span>2</span>
              <input
                className="ms-1"
                type="radio"
                name={`${currentQuestion?.question.id}`}
                value={!currentQuestion?.question?.choice?.choiceBImageUrl
                  ? currentQuestion?.question.choice?.b
                  : currentQuestion?.question?.choice?.choiceBImageUrl}

                checked={!currentQuestion?.question?.choice?.choiceBImageUrl
                  ? selectedAnswer === currentQuestion?.question.choice?.b
                  : selectedAnswer === currentQuestion?.question?.choice?.choiceBImageUrl}
                onChange={(e) => {
                  const value = e.target.value;
                  setSelectedAnswer(value);
                  setAnswers(prev => {
                    const existing = prev.find(a => a.questionId === currentQuestion?.question.id);
                    if (existing) {
                      return prev.map(a =>
                        a.questionId === currentQuestion?.question.id ? {
                          ...a, answer: value,
                          quizId: currentQuestion.quizId, userId: userId
                        } : a
                      );
                    } else {
                      return [...prev, {
                        questionId: currentQuestion?.question.id!,
                        answer: value, quizId: currentQuestion.quizId, userId: userId
                      }];
                    }
                  });
                }}
              />{" "}
              {
                currentQuestion?.question?.choice?.choiceBImageUrl ?
                  <img src={`${baseUrlPathImage.test}/${currentQuestion?.question.choice?.choiceBImageUrl}`} alt="ChoiceB" width="200" /> :
                  currentQuestion?.question.choice?.b
              }
            </div>

            <div   style={{ minWidth: "150px" }}>
              <span>3</span>
              <input
                className="ms-1"
                type="radio"
                name={`${currentQuestion?.question.id}`}
                value={!currentQuestion?.question?.choice?.choiceCImageUrl
                  ? currentQuestion?.question.choice?.c
                  : currentQuestion?.question?.choice?.choiceCImageUrl}

                checked={!currentQuestion?.question?.choice?.choiceCImageUrl
                  ? selectedAnswer === currentQuestion?.question.choice?.c
                  : selectedAnswer === currentQuestion?.question?.choice?.choiceCImageUrl}
                onChange={(e) => {
                  const value = e.target.value;
                  setSelectedAnswer(value);
                  setAnswers(prev => {
                    const existing = prev.find(a => a.questionId === currentQuestion?.question.id);
                    if (existing) {
                      return prev.map(a =>
                        a.questionId === currentQuestion?.question.id ? {
                          ...a, answer: value,
                          quizId: currentQuestion.quizId, userId: userId
                        } : a
                      );
                    } else {
                      return [...prev, {
                        questionId: currentQuestion?.question.id!,
                        answer: value, quizId: currentQuestion.quizId, userId: userId
                      }];
                    }
                  });
                }}
              />{" "}
              {
                currentQuestion?.question?.choice?.choiceCImageUrl ?
                  <img src={`${baseUrlPathImage.test}/${currentQuestion?.question.choice?.choiceCImageUrl}`} alt="ChoiceC" width="200" /> :
                  currentQuestion?.question.choice?.c
              }
            </div>

            <div   style={{ minWidth: "150px" }}>
              <span>4</span>
              <input
                className="ms-1"
                type="radio"
                name={`${currentQuestion?.question.id}`}
                value={!currentQuestion?.question?.choice?.choiceDImageUrl
                  ? currentQuestion?.question.choice?.d
                  : currentQuestion?.question?.choice?.choiceDImageUrl}

                checked={!currentQuestion?.question?.choice?.choiceDImageUrl
                  ? selectedAnswer === currentQuestion?.question.choice?.d
                  : selectedAnswer === currentQuestion?.question?.choice?.choiceDImageUrl}
                onChange={(e) => {
                  const value = e.target.value;
                  setSelectedAnswer(value);
                  setAnswers(prev => {
                    const existing = prev.find(a => a.questionId === currentQuestion?.question.id);
                    if (existing) {
                      return prev.map(a =>
                        a.questionId === currentQuestion?.question.id ? {
                          ...a, answer: value,
                          quizId: currentQuestion.quizId, userId: userId
                        } : a
                      );
                    } else {
                      return [...prev, {
                        questionId: currentQuestion?.question.id!,
                        answer: value, quizId: currentQuestion.quizId, userId: userId
                      }];
                    }
                  });
                }}
              />{" "}
              {
                currentQuestion?.question?.choice?.choiceDImageUrl ?
                  <img src={`${baseUrlPathImage.test}/${currentQuestion?.question.choice?.choiceDImageUrl}`} alt="ChoiceD" width="200" /> :
                  currentQuestion?.question.choice?.d
              }
            </div>

            <div style={{ display: !currentQuestion?.question.choice?.e ? "none" : "block", minWidth: "150px" }}>
              <span>5</span>
              <input
                className="ms-1"
                type="radio"
                name={`${currentQuestion?.question.id}`}
                value={!currentQuestion?.question?.choice?.choiceEImageUrl
                  ? currentQuestion?.question.choice?.e
                  : currentQuestion?.question?.choice?.choiceEImageUrl}

                checked={!currentQuestion?.question?.choice?.choiceEImageUrl
                  ? selectedAnswer === currentQuestion?.question.choice?.e
                  : selectedAnswer === currentQuestion?.question?.choice?.choiceEImageUrl}
                onChange={(e) => {
                  const value = e.target.value;
                  setSelectedAnswer(value);
                  setAnswers(prev => {
                    const existing = prev.find(a => a.questionId === currentQuestion?.question.id);
                    if (existing) {
                      return prev.map(a =>
                        a.questionId === currentQuestion?.question.id ? {
                          ...a, answer: value,
                          quizId: currentQuestion.quizId, userId: userId
                        } : a
                      );
                    } else {
                      return [...prev, {
                        questionId: currentQuestion?.question.id!,
                        answer: value, quizId: currentQuestion.quizId, userId: userId
                      }];
                    }
                  });
                }}
              />{" "}
              {
                currentQuestion?.question?.choice?.choiceEImageUrl ?
                  <img src={`${baseUrlPathImage.test}/${currentQuestion?.question.choice?.choiceEImageUrl}`} alt="ChoiceE" width="200" /> :
                  currentQuestion?.question.choice?.e
              }
            </div>

          </div>


          <div className="d-flex justify-content-between mt-3">
            <button
              className="btn btn-secondary"
              onClick={handlePrev}
              disabled={currentIndex === 0}
            >
              Prev
            </button>
            <button
              className="btn btn-primary"
              onClick={handleNext}
              disabled={currentIndex === questions.length - 1}
            >
              Next
            </button>

            <button
              className="btn btn-success"
              onClick={() => handleSubmit()}
              disabled={currentIndex !== questions.length - 1 || loading}

            >
              Submit
            </button>

          </div>

        </div>
      </div>
    )
}

export default QuizView